import React, { Component } from 'react'
import {MasterLayout} from 'layout';
import {ThongKeGiamSatNhapDonCu} from 'modules/theo-doi-giam-sat';


export default class ThongKeGiamSatNhapDonCuPage extends Component {

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <ThongKeGiamSatNhapDonCu id={this.props.params.id}/>
      </MasterLayout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/theo-doi-giam-sat/ThongKeGiamSatNhapDonCuPage.jsx